<mat-expansion-panel *ngFor="let entry of meterEntries" hideToggle class="gridConnection-panel-header">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div>Type of Meter: {{entry.fg.value.type}}</div>
      <div>ID: {{entry.fg.value.ref}}</div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <digires-list-input [formGroup]="entry.fg"
                      [items]="allTypeOfMeterOptions"
                      [itemToLabel]="typeOfMeterOptionToLabel"
                      formCtrlName="type"
                      placeholder="Type of Meter (HV, MV)"
                      tooltip="Identification of the types of meter: HV (High Voltage), MV (Medium Voltage)."
  ></digires-list-input>

  <digires-text-input [textarea]="true"
                      [formGroup]="entry.fg"
                      formCtrlName="ref"
                      placeholder="ID for the Meter"
                      tooltip="The Identification (ID) number for the meter used for metering the electricity output of the project."
  ></digires-text-input>

  <digires-button icon="delete" [disabled]="disabled" (onClick)="onRemoveEntry(entry)"></digires-button>
</mat-expansion-panel>

<digires-button icon="add" [disabled]="disabled" (onClick)="onAddEntry()"></digires-button>
